<template>
  <div class="row">
    <div v-for="(data, id) in datas" :key="id" class="col-12">
      <div class="card card_grey mb_12">
        <div class="sub_title_2 m-b-20">{{ data.metricName }}</div>
        <div class="d-flex align-items-center m-b-20">
          <div class="data_text">
            {{ convertCurrency(data.value) }}
          </div>
          <div class="d-flex ms-2">
            <div
              class="d-inline-flex align-items-center"
              :class="
                data.achievementStatus == 'UP' ? 'badge_green' : 'badge_red'
              "
            >
              <IconSvg
                :color="data.achievementStatus == 'UP' ? 'green' : 'red'"
                :type="
                  data.achievementStatus == 'UP' ? 'chart_up' : 'chart_down'
                "
              />
              <div
                class="data_detil"
                :class="
                  data.achievementStatus == 'UP' ? 'text_green' : 'text_red'
                "
              >
                <span v-if="data.achievementStatus == 'UP'">+</span
                >{{ data.achievement }}%
              </div>
            </div>
            <div
              class="d-inline-flex align-items-center me-2"
              :class="data.trendStatus == 'UP' ? 'badge_green' : 'badge_red'"
            >
              <IconSvg
                :color="data.trendStatus == 'UP' ? 'green' : 'red'"
                :type="data.trendStatus == 'UP' ? 'arrow_up' : 'arrow_down'"
              />
              <div
                class="data_detil"
                :class="data.trendStatus == 'UP' ? 'text_green' : 'text_red'"
              >
                <span v-if="data.trendStatus == 'UP'">+</span>{{ data.trend }}%
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="col-12">
      <div class="card card_grey mb_12">
        <div class="sub_title_2 m-b-20">
          Average turnaround time for legal opinions (days)
        </div>
        <div class="m-b-20 d-flex align-items-center">
          <div class="data_text">
            {{ convertCurrency(data.turnaround_value) }}
          </div>
          <div class="d-flex ms-2">
            <div
              class="d-inline-flex align-items-center me-2"
              :class="
                data.turnaround_trend_status == 'UP'
                  ? 'badge_green'
                  : 'badge_red'
              "
            >
              <IconSvg
                :color="data.turnaround_trend_status == 'UP' ? 'green' : 'red'"
                :type="
                  data.turnaround_trend_status == 'UP'
                    ? 'arrow_up'
                    : 'arrow_down'
                "
              />
              <div
                class="data_detil"
                :class="
                  data.turnaround_trend_status == 'UP'
                    ? 'text_green'
                    : 'text_red'
                "
              >
                <span v-if="data.turnaround_trend_status == 'UP'">+</span
                >{{ data.turnaround_trend }}%
              </div>
            </div>
            <div
              class="d-inline-flex align-items-center"
              :class="
                data.turnaround_achievement_status == 'UP'
                  ? 'badge_green'
                  : 'badge_red'
              "
            >
              <IconSvg
                :color="
                  data.turnaround_achievement_status == 'UP' ? 'green' : 'red'
                "
                :type="
                  data.turnaround_achievement_status == 'UP'
                    ? 'chart_up'
                    : 'chart_down'
                "
              />
              <div
                class="data_detil"
                :class="
                  data.turnaround_achievement_status == 'UP'
                    ? 'text_green'
                    : 'text_red'
                "
              >
                <span v-if="data.turnaround_achievement_status == 'UP'">+</span
                >{{ data.turnaround_achievement }}%
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="card card_grey mb_12">
        <div class="sub_title_2 m-b-20">Settlement of Property Asset Dispute (%)</div>
        <div class="m-b-20 d-flex align-items-center">
          <div class="data_text">{{ convertCurrency(data.settlement_value) }}</div>
          <div class="d-flex ms-2">
            <div
              class="d-inline-flex align-items-center me-2"
              :class="
                data.settlement_trend_status == 'UP'
                  ? 'badge_green'
                  : 'badge_red'
              "
            >
              <IconSvg
                :color="data.settlement_trend_status == 'UP' ? 'green' : 'red'"
                :type="
                  data.settlement_trend_status == 'UP'
                    ? 'arrow_up'
                    : 'arrow_down'
                "
              />
              <div
                class="data_detil"
                :class="
                  data.settlement_trend_status == 'UP'
                    ? 'text_green'
                    : 'text_red'
                "
              >
                <span v-if="data.settlement_trend_status == 'UP'">+</span
                >{{ data.settlement_trend }}%
              </div>
            </div>
            <div
              class="d-inline-flex align-items-center"
              :class="
                data.settlement_achievement_status == 'UP'
                  ? 'badge_green'
                  : 'badge_red'
              "
            >
              <IconSvg
                :color="
                  data.settlement_achievement_status == 'UP' ? 'green' : 'red'
                "
                :type="
                  data.settlement_achievement_status == 'UP'
                    ? 'chart_up'
                    : 'chart_down'
                "
              />
              <div
                class="data_detil"
                :class="
                  data.settlement_achievement_status == 'UP'
                    ? 'text_green'
                    : 'text_red'
                "
              >
                <span v-if="data.settlement_achievement_status == 'UP'">+</span
                >{{ data.settlement_achievement }}%
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import IconSvg from "@/components/IconSvg.vue";
import { currencyFormatNumberComma } from "@/utils/helper";

export default {
  props: ["load", "datas"],
  components: {
    IconSvg,
  },
  methods: {
    convertCurrency(x) {
      const str = x.toString();
      if (str.includes(".")) {
        const cnv = str.split(".")[0];
        let dotIndex = str.indexOf(".");
        const after = str.slice(dotIndex + 1);
        return currencyFormatNumberComma(cnv) + "." + after;
      } else {
        return str;
      }
    },
  },
};
</script>
